export class ListMappableRolesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return ListMappableRolesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
